import * as React from "react";
import { Component, Fragment } from "react";
import { connect } from "react-redux";
import { IRootState } from "../../store";
import DispatchProps from "../../utils/DispatchProps";
import ApiService from "../ApiService";
import AssignmentAnalyticsImage from "../../images/menu_assignment_insights.png";
import AssignmentAnalyticsImageLocked from "../../images/menu_assignment_insights_locked.jpg";
import StudentAssignmentSearchImage from "../../images/menu_student_assignment_search.jpg";
import LinkCardSmall from "../LinkCardSmall";
import SchoolMenu from "../SchoolMenu";
import SchoolPageTitle from "../SchoolPageTitle";
import School, { licenseLevelIsAtLeast } from "../../models/School";

interface SchoolAssignmentMenuPageProps {
    tenantId: string;
    schoolCode: string;
    apiService: ApiService;
}

interface SchoolAssignmentMenuPageState {
    school?: School;
    loadingSchool: boolean;
}

class SchoolAssignmentMenuPage extends Component<SchoolAssignmentMenuPageProps & DispatchProps, SchoolAssignmentMenuPageState> {

    constructor(props: SchoolAssignmentMenuPageProps & DispatchProps) {
        super(props);

        this.state = {
            loadingSchool: false
        };
    }

    async componentDidMount(): Promise<void> {
        if (this.props.tenantId && this.props.schoolCode) {
            await this.loadSchool();
        }
    }

    async componentDidUpdate(prevProps: Readonly<SchoolAssignmentMenuPageProps & DispatchProps>, prevState: any) {
        if (this.props.tenantId !== prevProps.tenantId || this.props.schoolCode !== prevProps.schoolCode) {
            await this.loadSchool();
        }
    }

    async loadSchool() {
        this.setState({ loadingSchool: true });
        let school = await this.props.apiService.getSchool(this.props.tenantId, this.props.schoolCode);
        this.setState({ school, loadingSchool: false });
    }

    private assignmentAnalyticsLink = () => `/manage/${this.props.tenantId}/${this.props.schoolCode}/assignment-analytics-overview`;
    private studentAssignmentSearchLink = () => `/manage/${this.props.tenantId}/${this.props.schoolCode}/student-assignment-search`;
    private unlockAssignmentLink = () => `/manage/${this.props.tenantId}/${this.props.schoolCode}/unlock-assignment-analytics`;

    private getAssignmentAnalyticsImage() {
        if (this.state.loadingSchool) {
            return AssignmentAnalyticsImage;
        }

        if (!licenseLevelIsAtLeast(this.state.school?.license, "gold")) {
            return AssignmentAnalyticsImageLocked;
        }

        return AssignmentAnalyticsImage;
    }

    private getAssignmentAnalyticsLink() {
        if (this.state.loadingSchool) {
            return;
        }

        if (!licenseLevelIsAtLeast(this.state.school?.license, "gold")) {
            return this.unlockAssignmentLink();
        }

        return this.assignmentAnalyticsLink();
    }


    public render(): JSX.Element {
        return (
            <Fragment>
                <SchoolPageTitle tenantId={this.props.tenantId} schoolCode={this.props.schoolCode} title="Assignments Overview" reverse={true} />
                <SchoolMenu prefix="Assignments" />
                <div className="help-box help-box--site-type-selection">
                    <LinkCardSmall
                        title="Assignment Analytics"
                        description="Identify gaps in assignment setting and improve completion rates."
                        image={this.getAssignmentAnalyticsImage()}
                        href={this.getAssignmentAnalyticsLink()} >
                    </LinkCardSmall>
                    <LinkCardSmall
                        title="Student Assignment Search"
                        description="For any student, see what assignments they are working on."
                        image={StudentAssignmentSearchImage}
                        href={this.studentAssignmentSearchLink()} >
                    </LinkCardSmall>
                </div>
            </Fragment>
        );
    }
}

export default connect(
    (state: IRootState, ownProps: { match: any }): SchoolAssignmentMenuPageProps => {

        const tenantId = ownProps.match.params.tenantId;
        const schoolCode = ownProps.match.params.schoolCode;

        return {
            tenantId,
            schoolCode,
            apiService: state.auth.apiService
        };
    }
)(SchoolAssignmentMenuPage)